// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list[data-v-cf9d1f94]{width:100%;border-spacing:0}.list__head__title[data-v-cf9d1f94]{text-align:left;color:#c6c8cd;font-size:16px;font-weight:400;letter-spacing:.24px;border-bottom:1px solid #1c252f;padding-bottom:8px}@media(max-width:700px){.offers[data-v-cf9d1f94]{display:none}}.top-rank[data-v-cf9d1f94]{text-align:center}", ""]);
// Exports
module.exports = exports;
